import { createSelector } from '@reduxjs/toolkit';
import {
    displayNameFromAccount,
    getPrimaryAppRoleFromAccount,
} from '@/features/auth/utils/mapBackendRole';
import { getEffectivePermissions } from '@/utils/accountPermissions';

export const selectAuthUser = (state) => state.auth?.user;

export const selectIsAuthenticated = (state) => state.auth?.isAuthenticated ?? false;

export const selectAuthLoading = (state) => state.auth?.isLoading ?? false;

export const selectAuthError = (state) => state.auth?.error;

/** Backend account → app role for routing / guards */
export const selectUserRole = createSelector([selectAuthUser], (account) =>
    account ? getPrimaryAppRoleFromAccount(account) : null
);

/** Effective bitmask merged from all roles’ `permissions` (aligned with API `checkPermission`). */
export const selectEffectivePermissions = createSelector([selectAuthUser], (account) =>
    account ? getEffectivePermissions(account) : 0
);

/**
 * Shape expected by layouts / RoleGuard (matches former AuthContext user).
 */
export const selectContextUser = createSelector([selectAuthUser], (account) => {
    if (!account?.user) return null;
    return {
        username: displayNameFromAccount(account) || account.userName,
        role: getPrimaryAppRoleFromAccount(account),
        userId: account.user.id,
        accountId: account.id,
        permissions: getEffectivePermissions(account),
        firstName: account.user.firstName,
        lastName: account.user.lastName,
        gender: account.user.gender,
        /** False while the account still uses a temporary password. */
        passwordChanged: account.passwordChanged !== false,
    };

});
